<template>
  <label class="d-flex align-items-center">
    <div class="checkbox">
      <input type="checkbox"
             :name="name"
             :checked="value === 'active'"
             :value="value"
             @input="input"
      >
      <img src="/img/check.svg" alt="">
    </div>
    <span>{{label}}</span>
  </label>
</template>

<script>
  import inputMixin from '../../mixins/inputMixin';

  export default {
    name: "InputCheckbox",
    props: {
      label: {
        type: String
      }
    },
    methods: {
      input(e) {
        let check;
        if (e.target.checked) {
          check = 'active';
        }
        else {
          check = 'inactive';
        }
        this.$emit('input', check);
      }
    },
    mixins: [inputMixin],
  }
</script>

<style lang="scss">
  @import "../../style/var";

  .checkbox {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 23px;
    max-width: 23px;
    height: 23px;
    padding-bottom: 3px;
    margin-right: 10px;
    border: 1px solid #C9C9C9;
    img {
      opacity: 0;
      transition: $transition;
    }
    input {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;
      &:checked {
        & + img {
          opacity: 1;
        }
      }
    }
  }
</style>